/**
 * Generic formatters for dates, numbers, strings.
 */

/** Format date string to display format (e.g. "15 Jan 2025") */
export function formatDateDisplay(dateStr) {
  if (!dateStr) return '—';
  const d = new Date(dateStr);
  if (Number.isNaN(d.getTime())) return String(dateStr);
  const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  return `${d.getDate()} ${months[d.getMonth()]} ${d.getFullYear()}`;
}

/** Format time string for display */
export function formatTimeDisplay(timeStr) {
  if (!timeStr || typeof timeStr !== 'string') return '—';
  const t = timeStr.trim();
  if (!t) return '—';
  const parts = t.split(':').map((p) => parseInt(String(p).trim(), 10) || 0);
  const h = parts[0] ?? 0;
  const m = parts[1] ?? 0;
  if (h === 0 && m === 0) return '12:00 AM';
  if (h < 12) return `${h}:${String(m).padStart(2, '0')} AM`;
  if (h === 12) return `12:${String(m).padStart(2, '0')} PM`;
  return `${h - 12}:${String(m).padStart(2, '0')} PM`;
}

/** Format number with Indian locale (e.g. 1,00,000) */
export function formatNumber(num) {
  if (num == null || Number.isNaN(num)) return '0';
  return new Intl.NumberFormat('en-IN').format(num);
}

/** Format currency (INR) */
export function formatCurrency(amount, currency = 'INR') {
  if (amount == null || Number.isNaN(amount)) return '₹0';
  return new Intl.NumberFormat('en-IN', { style: 'currency', currency }).format(amount);
}
